import { Errors } from "../utils/errors";
import { loadTFJSModelFromDB } from "../utils/utils";


export default class VehicleDetection{
    constructor () {
        return (async () => {
            this.config = await this.loadConfig();
            this.model  = await this.loadModel();
            this.allowed_classes = this.config["CLASSES"];

            this.hasError = false;
            this.NUM_CLASS = 4;
            this.errorMessage = "";
            return this;
          })();
    }
    checkModelisLoaded(){
        if(this.model != undefined){
            return true;
        }else{
            return false;
        }
    }
    async loadConfig(){
        return fetch("../config/config.json").then((res)=>{            
            return res.json();
        }).then((data)=>{
            return data;
        }).catch((err)=>{
            console.error(err)
        });

    }

    async loadModel(){
        try{
            if (this.checkModelisLoaded()){
                return this.model;
            }
            const [model_json,model_weight] = await loadTFJSModelFromDB(this.config["URLS"]["VEHICLE_DET_MODEL_JSON"],this.config["URLS"]["VEHICLE_DET_MODEL_WEIGHT"],"VEHICLE_DET_MODEL_JSON","VEHICLE_DET_MODEL_WEIGHT")
        
            let mw1 = new File([model_weight], "group1-shard1of1.bin");
            let uint8Array = new Uint8Array(model_json);

            const decoder = new TextDecoder('utf-8');
            const string1 = decoder.decode(uint8Array);
            // let string1 =  String.fromCharCode.apply(null, uint8Array);

            let mj1 = new File([string1], "model.json", {
                type: "application/json",
            });

            let model = await window.tf.loadGraphModel(
                window.tf.io.browserFiles([mj1,mw1])
            )
            
            return model; 
        }catch(error){
            console.log(error)
            this.hasError = true;
        }
        
    }
    resizeAndPadding(img, newWidth, newHeight, color) {
        const [paddedImg,sx,sy,dx,dy]=window.tf.tidy(()=>{
            let tmpImg = img instanceof window.tf.Tensor ? img : window.tf.browser.fromPixels(img);
            const [origHeight, origWidth, channels] = tmpImg.shape;
            const scale = Math.min(newWidth / origWidth, newHeight / origHeight);
            const nw = Math.floor(origWidth * scale);
            const nh = Math.floor(origHeight * scale);
            tmpImg = window.tf.image.resizeBilinear(tmpImg, [nh, nw]).toInt();
            const dx = Math.floor((newWidth - nw) / 2);
            const dy = Math.floor((newHeight - nh) / 2);
            const padTop = window.tf.tensor(color, [1, 1, 3], 'int32').tile([dy, newWidth, 1]);
            const padBottom = window.tf.tensor(color, [1, 1, 3], 'int32').tile([newHeight - nh - dy, newWidth, 1]);
            const padLeft = window.tf.tensor(color, [1, 1, 3], 'int32').tile([nh, dx, 1]);
            const padRight = window.tf.tensor(color, [1, 1, 3], 'int32').tile([nh, newWidth - nw - dx, 1]);
            const paddedImg = window.tf.concat([
                padTop,
                window.tf.concat([padLeft, tmpImg, padRight], 1),
                padBottom
            ], 0);
    
            window.tf.dispose([padTop,padBottom,padLeft,padRight,tmpImg]);
            return [paddedImg , nw/origWidth , nh/origHeight , dx,dy];
        });
        return [paddedImg,sx,sy,dx,dy];
        
    }
    preProcess(img,add_pad=true){
        const [norm_img,sx,sy,dx,dy] = window.tf.tidy(()=>{
            let paddedImg = img;
            let sx = 1;
            let sy = 1;
            let dx = 0;
            let dy = 0;
            if(add_pad){
                [paddedImg,sx,sy,dx,dy] =  this.resizeAndPadding(img,this.config["INPUTS"]["VEHICLE_DETECTION_INPUT_HEIGHT"],this.config["INPUTS"]["VEHICLE_DETECTION_INPUT_WIDTH"],[114,114,114]);
                paddedImg = paddedImg.div(255.0);
            }else{
                paddedImg = window.tf.image.resizeBilinear(paddedImg, [this.config["INPUTS"]["VEHICLE_DETECTION_INPUT_HEIGHT"], this.config["INPUTS"]["VEHICLE_DETECTION_INPUT_WIDTH"]]).div(255.0);
            }

            const norm_img =  paddedImg.expandDims(0); 
            return [norm_img,sx,sy,dx,dy];
        });
        return [norm_img,sx,sy,dx,dy];
    }
    postProcess(output) {
        const [boxes_data, scores_data, classes_data] = window.tf.tidy(()=>{
            const transRes = output.transpose([0, 2, 1]);
            let boxes = window.tf.tidy(() => {
                const xc = transRes.slice([0, 0, 0], [-1, -1, 1]); 
                const yc = transRes.slice([0, 0, 1], [-1, -1, 1]); 
                const w = transRes.slice([0, 0, 2], [-1, -1, 1]);  
                const h = transRes.slice([0, 0, 3], [-1, -1, 1]); 
        
                const x1 = xc.sub(w.div(2)); 
                const y1 = yc.sub(h.div(2)); 
        
                const boxes = window.tf.concat(
                    [
                        y1,
                        x1,
                        y1.add(h), 
                        x1.add(w), 
                    ],
                    2
                ).squeeze();
                return boxes;
            });
        
            const [scores, classes] = window.tf.tidy(() => {
                const rawScores = transRes.slice([0, 0, 4], [-1, -1, this.NUM_CLASS]).squeeze(0);
                const maxScores = rawScores.max(1); 
                const argMaxClasses = rawScores.argMax(1); 
                rawScores.dispose();
                return [maxScores, argMaxClasses];
            });
        
            const nms =  window.tf.image.nonMaxSuppression(
                boxes,
                scores,
                300,
                this.config["THRESHOLDS"]["IOU_THRESHOLD"],
                this.config["THRESHOLDS"]["SCORE_THRESHOLD"]
            );
        
            const boxes_data = boxes.gather(nms, 0).dataSync();
            const scores_data = scores.gather(nms, 0).dataSync();
            const classes_data = classes.gather(nms, 0).dataSync();
            return [boxes_data, scores_data, classes_data];

        });

        return [boxes_data, scores_data, classes_data];

    }

    
    mapBoundingBoxToOriginal(x, y, sx, sy, dx, dy) {
        x = x - dx;
        y = y - dy;
        x = x / sx;
        y = y / sy;
        return [x,y];
    }
    
    draw(input_canvas,scores_data,boxes_data,classes_data,sx,sy,dx,dy,input_width,input_height){
        const ctx = input_canvas.getContext("2d");
        for (let i = 0; i < scores_data.length; ++i) {
            const klass = classes_data[i];
            const color = 'red';
            const score = (scores_data[i] * 100).toFixed(1);
            let [y1_, x1_, y2_, x2_] = boxes_data.slice(i * 4, (i + 1) * 4);

            let [x1, y1] = this.mapBoundingBoxToOriginal(x1_, y1_ ,  sx, sy, dx, dy, input_width,input_height);
            let [x2, y2] = this.mapBoundingBoxToOriginal(x2_, y2_ ,  sx, sy, dx, dy, input_width,input_height);

            const width = x2 - x1;
            const height = y2 - y1;
            ctx.fillStyle = color;
            ctx.lineWidth = Math.max(Math.min(ctx.canvas.width, ctx.canvas.height) / 200, 2.5);
            ctx.strokeRect(x1, y1, width, height);
            const textWidth = ctx.measureText(klass + " - " + score + "%").width;
            const textHeight = 5;
            const yText = y1 - (textHeight + ctx.lineWidth);
            ctx.fillRect(
            x1 - 1,
            yText < 0 ? 0 : yText, 
            textWidth + ctx.lineWidth,
            textHeight + ctx.lineWidth
            );
            ctx.fillStyle = "#ffffff";
            ctx.fillText(klass + " - " + score + "%", x1 - 1, yText < 0 ? 0 : yText);
        }
    }

    getLargestVehicle(vehicles){
        return vehicles.reduce((largestCanvas, currentCanvas) => {
            const largestArea = largestCanvas.vehicle.width * largestCanvas.vehicle.height;
            const currentArea = currentCanvas.vehicle.width * currentCanvas.vehicle.height;
            return currentArea > largestArea ? currentCanvas : largestCanvas;
        });
    }


    getVehicles(canvas, boxes_data, scores_data, classes_data, sx, sy, dx, dy, input_width, input_height) {
        let croppedImages = [];
        const ctx = canvas.getContext("2d");

        for (let i = 0; i < scores_data.length; i++) {
            const class_ = classes_data[i];
            if (!(class_ in this.allowed_classes)){
                continue
            }
            const score = (scores_data[i] * 100).toFixed(1);
            let [y1_, x1_, y2_, x2_] = boxes_data.slice(i * 4, (i + 1) * 4);
            
            let [x1, y1] = this.mapBoundingBoxToOriginal(x1_, y1_, sx, sy, dx, dy, input_width, input_height);
            let [x2, y2] = this.mapBoundingBoxToOriginal(x2_, y2_, sx, sy, dx, dy, input_width, input_height);

            x1 = Math.max(0, Math.floor(x1));
            y1 = Math.max(0, Math.floor(y1));
            x2 = Math.min(canvas.width, Math.ceil(x2));
            y2 = Math.min(canvas.height, Math.ceil(y2));

            const width = x2 - x1;
            const height = y2 - y1;

            const imageData = ctx.getImageData(x1, y1, width, height);
            const tempCanvas = document.createElement("canvas");
            tempCanvas.width = width;
            tempCanvas.height = height;
            const tempCtx = tempCanvas.getContext("2d");
            tempCtx.putImageData(imageData, 0, 0);
            croppedImages.push({"boxes":[x1,y1,x2,y2,score,class_],"vehicle":tempCanvas}); 
        }
        return croppedImages;
    }
    async processOutput(output,canvasRef,sx,sy,dx,dy,input_width,input_height){
        window.tf.engine().startScope();  
        let  [boxes_data, scores_data, classes_data] =  this.postProcess(output);
        if (boxes_data.length == 0 ){
            this.hasError = true;
            this.errorMessage = Errors.getMessage(Errors.NO_VEHICLE);
            window.tf.engine().endScope();
            return null;
        }
        // this.draw(image,scores_data,boxes_data,classes_data,sx,sy,dx,dy,this.config["VEHICLE_DETECTION_INPUT_WIDTH"],this.config["VEHICLE_DETECTION_INPUT_HEIGHT"]);

        let vehicles = this.getVehicles(canvasRef , boxes_data, scores_data, classes_data,sx,sy,dx,dy,input_width,input_height);
        if (vehicles.length==0){
            this.hasError = true;
            this.errorMessage = Errors.getMessage(Errors.NO_VALID_VEHICLE);
            window.tf.engine().endScope();
            return null;
        }
        // let largest_vehicle = this.getLargestVehicle(vehicles);
        window.tf.engine().endScope();
        return vehicles;
    }
    
    async detect(image){
        this.hasError=false;
        this.errorMessage="";
        window.tf.engine().startScope();
        const image_tensor = window.tf.browser.fromPixels(image);
        let [input,sx,sy,dx,dy] =  this.preProcess(image_tensor,true);
        const output = await this.model.execute(input); 
        // const largest_vehicle = await this.processOutput(output,image,sx,sy,dx,dy,this.config["VEHICLE_DETECTION_INPUT_WIDTH"],this.config["VEHICLE_DETECTION_INPUT_HEIGHT"]);
        const vehicles = await this.processOutput(output,image,sx,sy,dx,dy,this.config["VEHICLE_DETECTION_INPUT_WIDTH"],this.config["VEHICLE_DETECTION_INPUT_HEIGHT"]);
        if(this.hasError){
            window.tf.engine().endScope();
            return [null,this.hasError,this.errorMessage];
        }else{
            // document.body.appendChild(largest_vehicle.vehicle);
        }
        window.tf.engine().endScope();
        return [vehicles,this.hasError,this.errorMessage];
    }

}